module.exports = __webpack_public_path__ + "static/media/mask12.6c615512.JPG";